
<section class="referencesHomeUK" [innerHTML]="safeh2content"></section>
